export const EDITABLE_ACCOUNT_TYPES = ['USER', 'OFFICIAL', 'REVIEWER', 'TESTER'];

export function isEditableAccountType(accountType) {
  return EDITABLE_ACCOUNT_TYPES.includes(accountType);
}
